import Icon from '../../components/Icon.vue'

Icon.register({"regular/sticky-note":{"width":448,"height":512,"paths":[{"d":"M448 348.1V80C448 53.5 426.5 32 400 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H316.1A48-48 0 0 1 350.1 465.9L433.9 382A48-48 0 0 1 448 348.1zM320 428.1V352H396.1L320 428.1zM400 80V304H296C282.7 304 272 314.7 272 328V432H48V80H400z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/regular/sticky-note.js
// module id = null
// module chunks = 